export default __webpack_public_path__ + "static/media/kalechips-wide@2x.73a335df.jpg";